import Slider from "react-slick";
import { Container, Fade } from "react-bootstrap";
import "./carousel.css";

const Entry =
    "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/office-entry.webp";
const InteriorView1 =
    "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/interior-1.webp";
const InteriorView2 =
    "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/interior-2.webp";
const Reception =
    "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/reception.webp";

const testimonials = [
    {
        imgSrc: Entry,
    },
    {
        imgSrc: InteriorView1,
    },
    {
        imgSrc: InteriorView2,
    },
    {
        imgSrc: Reception,
    },
];

const OfficeCarousel = () => {
    const officeCarousel = {
        dots: false,
        infinite: true,
        fade: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
    };

    return (
        <section className="px-0">
            <Container fluid>
                <Slider {...officeCarousel} className="testimonial-carousel">
                    {testimonials.map((testimonial, index) => (
                        <div className="pt-50" key={index}>
                            <img src={testimonial.imgSrc} alt="office-img" loading="lazy" />
                        </div>
                    ))}
                </Slider>
            </Container>
        </section>
    );
};

export default OfficeCarousel;
